import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './ProjectCard.css';

function ProjectCard({ id, title, period, description, stack, imageUrl, imageVariant, mediaBg, link }) {
  const cardRef = useRef(null);
  const { t } = useTranslation();
  const defaultImage = '/butterfly.png';

  const displayDesc = id
    ? t(`projects.items.${id}.description`, { defaultValue: description })
    : description;
  const displayPeriod = id
    ? t(`projects.items.${id}.period`, { defaultValue: period })
    : period;
  const linkText = t('projects.viewLink', { defaultValue: 'View Project →' });

  const imgClass = [
    'project-card__image',
    imageVariant === 'badge' && 'project-card__image--badge',
  ].filter(Boolean).join(' ');

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const cx = rect.width / 2;
    const cy = rect.height / 2;
    const rotateX = ((y - cy) / cy) * -7;
    const rotateY = ((x - cx) / cx) * 7;
    card.style.transform = `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.03)`;
    const shine = card.querySelector('.project-card__shine');
    if (shine) {
      shine.style.background = `radial-gradient(circle at ${x}px ${y}px, rgba(255,255,255,0.12) 0%, transparent 65%)`;
    }
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;
    if (!card) return;
    card.style.transform = '';
    const shine = card.querySelector('.project-card__shine');
    if (shine) shine.style.background = 'none';
  };

  return (
    <article
      className="project-card"
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className="project-card__shine" aria-hidden="true" />

      <div
        className="project-card__media"
        style={mediaBg ? { background: mediaBg } : undefined}
      >
        <img
          src={imageUrl || defaultImage}
          alt={`${title} 미리보기`}
          className={imgClass}
          onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }}
        />
      </div>

      <div className="project-card__body">
        <header className="project-card__header">
          <h3 className="project-card__title">{title}</h3>
          {displayPeriod && <p className="project-card__period">{displayPeriod}</p>}
        </header>
        <p className="project-card__desc">{displayDesc}</p>
        {stack && (
          <ul className="project-card__stack" aria-label="Tech Stack">
            {stack.map((tech, i) => <li key={i}>{tech}</li>)}
          </ul>
        )}
        {link && (
          <a className="project-card__link" href={link} target="_blank" rel="noopener noreferrer">
            {linkText}
          </a>
        )}
      </div>
    </article>
  );
}

export default ProjectCard;
